import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Activity, Hand, Droplets, Sparkles, Zap, Waves, Flame, Radio } from 'lucide-react';

const Leistungen = () => {
  const services = [
    {
      icon: Activity,
      title: 'Krankengymnastik',
      description: 'Individuelle Bewegungstherapie zur Verbesserung von Beweglichkeit, Kraft und Koordination. Geeignet bei orthopädischen, neurologischen und inneren Erkrankungen.'
    },
    {
      icon: Hand,
      title: 'Manuelle Therapie',
      description: 'Gezielte Mobilisation von Gelenken und Behandlung von Funktionsstörungen des Bewegungssystems. Effektiv bei Gelenkblockaden und Bewegungseinschränkungen.'
    },
    {
      icon: Droplets,
      title: 'Lymphdrainage',
      description: 'Sanfte, entstauende Therapie zur Anregung des Lymphabflusses. Besonders wirksam bei Schwellungen nach Operationen oder bei Lymphödemen.'
    },
    {
      icon: Sparkles,
      title: 'Massage',
      description: 'Klassische und therapeutische Massagetechniken zur Lockerung der Muskulatur, Schmerzlinderung und Förderung der Durchblutung.'
    },
    {
      icon: Zap,
      title: 'Elektrotherapie',
      description: 'Behandlung mit elektrischen Strömen zur Schmerzlinderung, Muskelstimulation und Förderung der Heilungsprozesse.'
    },
    {
      icon: Radio,
      title: 'Ultraschalltherapie',
      description: 'Therapeutische Anwendung von Ultraschallwellen zur Behandlung von Schmerzen, Entzündungen und zur Förderung der Gewebeheilung.'
    },
    {
      icon: Flame,
      title: 'Wärmeanwendungen / Fango',
      description: 'Wärmetherapie zur Muskelentspannung, Durchblutungsförderung und Vorbereitung auf weitere Behandlungen.'
    },
    {
      icon: Waves,
      title: 'Stoßwellentherapie',
      description: 'Moderne, nicht-invasive Behandlungsmethode bei chronischen Schmerzen und Verkalkungen. Besonders effektiv bei Fersensporn, Tennisarm und Kalkschulter.'
    }
  ];

  return (
    <div className="page-container">
      <section className="page-hero">
        <div className="section-container">
          <h1 className="page-title">Physiotherapeutische Leistungen</h1>
          <p className="page-subtitle">
            Umfassende Behandlung auf Verordnung Ihres Arztes
          </p>
        </div>
      </section>

      <section className="page-content">
        <div className="section-container">
          <div className="leistungen-intro">
            <img 
              src="https://customer-assets.emergentagent.com/job_physiograu/artifacts/4vr293j4_IMG_7177.JPG" 
              alt="Behandlungsraum"
              className="leistungen-image"
            />
            <div className="leistungen-text">
              <h2 className="subsection-title">Unsere Arbeitsweise</h2>
              <p className="text-content">
                In unserer Praxis steht Ihre individuelle Betreuung im Mittelpunkt. Wir nehmen uns 
                Zeit für eine gründliche Befundung und erstellen einen auf Sie abgestimmten Behandlungsplan.
              </p>
              <p className="text-content">
                Jede Therapie wird an Ihre persönlichen Bedürfnisse und Ihr Beschwerdebild angepasst. 
                Unser Ziel ist es, Ihre Beschwerden zu lindern und Ihre Beweglichkeit nachhaltig zu verbessern.
              </p>
            </div>
          </div>

          <h2 className="subsection-title services-title">Unsere Behandlungsmethoden</h2>
          <div className="leistungen-grid">
            {services.map((service, index) => {
              const IconComponent = service.icon;
              return (
                <Card key={index} className="leistung-card">
                  <CardContent className="leistung-card-content">
                    <IconComponent className="leistung-icon" />
                    <h3 className="leistung-title">{service.title}</h3>
                    <p className="leistung-description">{service.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          <div className="leistungen-note">
            <p className="note-text">
              Alle Leistungen werden auf Verordnung Ihres Arztes durchgeführt und von den 
              gesetzlichen und privaten Krankenkassen übernommen.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Leistungen;